module.exports = __webpack_public_path__ + "img/hydrology.66307f07.jpg";